import React from "react";
import BaseBadge from "@reusables/BaseBadge";

export default function BetaBadge(){
    return (
        <BaseBadge>
            Beta
        </BaseBadge>
    );
}